import {OAuthService} from "@/service/oauth";

const state = {};

const getters = {};

const actions = {
    getConsent(ctx, requestId) {
        return OAuthService.getConsent(requestId);
    },

    approve(ctx, requestId) {
        return OAuthService.decide(requestId, true);
    },

    deny(ctx, requestId) {
        return OAuthService.decide(requestId, false);
    },
};

const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
